import '../css/app.css'
import '../css/fonts.css'
import '../css/markdown.css'
import './bootstrap'

import AppLayout from '@/layouts/AppLayout.vue'
import { createInertiaApp, Head, Link } from '@inertiajs/vue3'
import * as Sentry from '@sentry/vue'
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers'
import { createApp, h } from 'vue'

const appName = import.meta.env.VITE_APP_NAME || 'Kalianko'

createInertiaApp(
    {
        title: (title) => (title ? `${title} - ${appName}` : appName),
        resolve: async (name) => {
            const page = await resolvePageComponent(`./pages/${name}.vue`, import.meta.glob('./pages/**/*.vue'))

            page.default.layout = AppLayout

            return page
        },
        setup({ el, App, props, plugin }) {
            const app = createApp({ render: () => h(App, props) })
                .use(plugin)
                .component('Head', Head)
                .component('Link', Link)

            Sentry.init({
                app,
                dsn: import.meta.env.VITE_SENTRY_DSN,
                tracesSampleRate: 1.0,
                environment: import.meta.env.VITE_APP_ENV,
            })

            return app.mount(el)
        },
        progress: {
            color: '#4B5563',
        },
        defaults: {
            visitOptions: () => ({
                viewTransition: (transition) => {
                    transition.ready.catch(() => {})
                    transition.finished.catch(() => {})
                },
            }),
        },
    },
    {
        cluster: true,
    }
)
